exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-list-item[data-v-3f97364c]:hover {\n    text-decoration: none;\n}\n.v-list-item__content[data-v-3f97364c] {\n    height: 56px;\n}\n", ""]);

// exports
